module.exports = {
  IN: 'https://tnc.dominos.co.in/zeroContactDelivery.html',
  LK: 'https://tnc.dominos.co.in/src/SriLanka_ZC.html',
  BG: 'https://tnc.dominos.com.bd/src/Bangladesh_ZC.html'
}